import React from 'react';

const ClientsTabComponent = ({ count, activeItem, triggerTab }) => {
	return (
		<div>
			<div className="navigation-tab shadow-nav-4dp bg-white">
				<ul>
					<li
						className={activeItem === 'PENDING' ? 'active' : ''}
						onClick={() => triggerTab('PENDING')}
					>
						Pending {count > 0 && <span className="clients-count">{count + ' New'}</span>}
					</li>
					<li className={activeItem === 'ALL' ? 'active' : ''} onClick={() => triggerTab('ALL')}>
						All client
					</li>
				</ul>
			</div>
		</div>
	);
};

export default ClientsTabComponent;
